import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import Popup from 'src/components/content/popup/popup';
import ContentWrapper from 'src/components/content/content-wrapper';

import styles from './modal.module.scss';
import ContentSection from 'src/components/content/content-section';
import colors from 'src/styles/equalution/colors';
import { Button } from 'reactstrap';
import TickGreen from 'src/assets/icons/tickGreen.svg';

interface Props {
  onClose: () => void;
}

export const PersonalCoachSuccessModal: FC<Props> = ({ onClose }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Popup onClose={handleClose}>
      <ContentWrapper className={styles.background}>
        <ContentSection className={styles.confirmContent} collapseAt="sm">
          <Button className={styles.close} onClick={handleClose} />

          <Stack alignItems={'center'} mt={3}>
            <img
              src={TickGreen}
              style={{ alignSelf: 'center' }}
              alt="success"
            />

            <Typography
              mt={2}
              fontSize={26}
              fontWeight={700}
              color={colors.OFF_BLACK}
              textAlign="center"
              paddingX={'32px'}
              gutterBottom>
              Coaching Add-On was successfully added
            </Typography>

            <Button
              onClick={handleClose}
              size="md"
              style={{ marginTop: '20px', width: '100%' }}
              variant="primary">
              Ok
            </Button>
          </Stack>
        </ContentSection>
      </ContentWrapper>
    </Popup>
  );
};
